import { all, takeEvery, put, fork } from 'redux-saga/effects';

import axios from './initialize'
import { Modal } from 'antd';
import {CheckCircleFilled} from  '@ant-design/icons';

import {  GET_CONNECTORS_API_LIST,UPDATE_CONNECTOR_API,DELETE_CONNECTOR_API,ADD_CONNECTOR_API,TEST_CONNECTOR, GET_INSTANCE_CONNECTORS_API_LIST, UPDATE_INSTANCE_CONNECTOR_API} from "redux/constants/connector";

import { connectorList, showConnectorApisMessage,testConnectorData,connectorData,registerSuccess, deleteConnector,connectorInstanceList, hideLoading } from "redux/actions/connector";
import { showUnAutherizeMessage} from "redux/actions/Auth";
import { CONNECTOR_BASE_URL } from 'configs/AppConfig';
import {AUTH_TOKEN} from '../constants/Auth';
import {PATH_VARIABLE} from 'constants/ApiConstant';
import { t } from 'i18next';
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";

export function* getConnector(){
    yield takeEvery (GET_CONNECTORS_API_LIST, function*  ({requestData}){
		const {query, sorter,pagination,appId} = requestData;
      const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountId: localStorage.getItem("accountId"),
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${CONNECTOR_BASE_URL}/connector/connector-api?appId=${appId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_get_connector`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `Connector Retrieve Sucessfully `,
						action: `Search Get Connector `,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_connector`,
					event: 'click',
					message: `Connector Retrieve Sucessfully For appId=${appId}`,
					status: `Tested Connector Sucessfully `,
					action: `Clicked Get Connector `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(connectorList(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_get_connector`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Retrieve  Connector `,
					action: `Search Get Connector `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_connector`,
				event: 'click',
				message: `Failed To Retrieve  Connector For appId=${appId}`,
				status: `Failed To Retrieve  Connector  `,
				action: `Clicked Get Connector `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.data?.status==401){
				yield put(showConnectorApisMessage(err.response));
			}
			yield put(showConnectorApisMessage(err.response));
		}
    }

    )
}

export function* testConnector(){
    yield takeEvery (TEST_CONNECTOR, function*  ({requestData}){
		const {query, sorter,pagination,appId,appInstanceId,values,requestJsonData } = requestData;
      const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `${localStorage.getItem(AUTH_TOKEN)}`,
		"accountId" : localStorage.getItem("accountId"),
		accountUserId: localStorage.getItem("accountUserId"),
		"appId":appId }
	  };
		try {
		const res = yield  axios.post(`${CONNECTOR_BASE_URL}/connector/v1/test-connector-api?appId=${appId}&appInstanceId=${appInstanceId}&query=${query}&sortfield=${sorter?.field}&
		sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,requestData,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_test_connector`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `Tested Connector Sucessfully `,
						action: `Search Test Connector `,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `test_connector`,
					event: 'click',
					message: `Tested Connector Sucessfully For appId=${appId}`,
					status: `Tested Connector Sucessfully `,
					action: `Clicked Test Connector`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(testConnectorData(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_test_connector`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Search Test Connector`,
					action: `Search Test Connector `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `test_connector`,
				event: 'click',
				message: `Failed To Test Connector For appId=${appId}`,
				status: `Failed To Test Connector `,
				action: `Clicked Test Connector`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err.response.data.status===401){
				yield put(showConnectorApisMessage(err.response));
			}
			yield put(showConnectorApisMessage(err.response));
		}
    }

    )
}

export function* saveConnector() {
	yield takeEvery(ADD_CONNECTOR_API, function* ({ payload }) {
	  try {
	//	const accountId = localStorage.getItem("accountId");
		const {query, sorter,pagination,values,appId} = payload;
		const config = {
		  headers: {
			"Content-Type": "application/json",
			"Access-Control-Allow-Origin": "*",
			"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			"accountId" : localStorage.getItem("accountId"),
			"appInstanceId":localStorage.getItem("appInstanceId"),
			accountUserId: localStorage.getItem("accountUserId")
		  },
		};
		const response = yield axios.post(
		  `${CONNECTOR_BASE_URL}/connector/connector-api`,
		  values,
		  config
		);
		if (response.status === 200) {
			const traceObj ={
				type: `connector_save`,
				event: 'click',
				message: `Connector Save Sucessfully`,
				status: `Connector Save Sucessfully `,
				action: `Clicked save connector`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			const res = yield  axios.get(`${CONNECTOR_BASE_URL}/connector/connector-api?appId=${appId || values.connectorId}&query=${query ?? ''}&sortfield=${sorter?.field}
				 &sortorder=${sorter?.order}&page=${(pagination?.current ?? 1) - 1}&size=${pagination?.pageSize ?? 10}`,
				 {headers: {
					'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
					'Access-Control-Allow-Origin' : '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					accountId: localStorage.getItem("accountId"),
					accountUserId: localStorage.getItem("accountUserId")
				  }});
					if (res.status===200) {
		  Modal.success({
			title: t("impaqx.adminApp.connectorApiAddMessage"),
			icon: <CheckCircleFilled />,
			okText: t("impaqx.adminApp.close"),
			//cancelText: 'Cancel',
			onOk() {
			  //deleteApp(id);
			},
		  });
		  yield put(connectorList(res.data));
		}
		}
		yield put(hideLoading());
		
	  } catch (err) {
		const traceObj ={
			type: `connector_save`,
			event: 'click',
			message: `Failed To Save Connector`,
			status: `Failed To Save Connector`,
			action: `Clicked save connector`,
			referer_action_id: localStorage.getItem("referer_action_id"),
			trackId: uuidv4(),
			user_session: sessionStorage.getItem("user_session")
		  };
		  localStorage.setItem("referer_action_id",traceObj.trackId);
		  trace({"traceObj":traceObj});
		console.log(err);
		yield put(hideLoading());
		yield put(showConnectorApisMessage(err.response));
	  }
	});
  }
export function* updateConnector(){
    yield takeEvery (UPDATE_CONNECTOR_API,function* ({payload}){
		const {query, sorter,pagination,values,appId} = payload;
        try {
            const res = yield axios.put(`${CONNECTOR_BASE_URL}/connector/connector-api/${values.id}`, values,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountId: localStorage.getItem("accountId"),
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
             if (res.status===200) {
				const traceObj ={
					type: ` update_connector`,
					event: 'click',
					message: `Connector Updated Sucessfully For Id=${values.id}`,
					status: `Connector Updated Sucessfully `,
					action: `Clicked update connector`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
					const response = yield  axios.get(`${CONNECTOR_BASE_URL}/connector/connector-api?appId=${appId || values.connectorId}&query=${query ?? ''}&sortfield=${sorter?.field}
						 &sortorder=${sorter?.order}&page=${(pagination?.current ?? 1) - 1}&size=${pagination?.pageSize ?? 10}`,
						 {headers: {
							'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
							'Access-Control-Allow-Origin' : '*',
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							accountId: localStorage.getItem("accountId"),
							accountUserId: localStorage.getItem("accountUserId")
						  }});
							if (response.status===200) {
				Modal.success({
					title: t("impaqx.adminApp.connectorCreateMessage"),
					icon: <CheckCircleFilled />,
					okText: t("impaqx.adminApp.close"),
					//cancelText: 'Cancel',
					onOk() {
					  //deleteApp(id);
					},
				  });
				  yield put(connectorList(response.data));
				} 
		}
		yield put(hideLoading());
        } catch (error) {
			const traceObj ={
				type: ` update_connector`,
				event: 'click',
				message: `Failed To Update Connector For Id=${values.id}`,
				status: `Failed To Update Connector `,
				action: `Clicked update connector`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
            console.log(error);
			yield put(hideLoading());
			if(error.response?.data?.status===401){
				yield put(showConnectorApisMessage(error.response));
			}
			yield put(showConnectorApisMessage(error.response));
        }
    }
    )
}

export function* deleteConnectorApi(){
	yield takeEvery(DELETE_CONNECTOR_API, function*({payload}){
         try {
			const {query, sorter,pagination,connector} = payload;
			 const res = yield axios.delete(`${CONNECTOR_BASE_URL}/connector/connector-api/${connector.id}`,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountId: localStorage.getItem("accountId"),
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
			 if(res.status===200){
				const traceObj ={
					type: `delete_connector_api`,
					event: 'click',
					message: `Connector Api Deleted Sucessfully For Id=${connector.id}`,
					status: `Connector Api Deleted Sucessfully`,
					action: `Clicked delete connector api`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				 //yield put(showAccountMessage(res));
				 const res = yield  axios.get(`${CONNECTOR_BASE_URL}/connector/connector-api?appId=${connector.connectorId}&query=${query}&sortfield=${sorter?.field}
				 &sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
				 {headers: {
					'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
					'Access-Control-Allow-Origin' : '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					accountId: localStorage.getItem("accountId"),
					accountUserId: localStorage.getItem("accountUserId")
				  }});
					if (res.status===200) {
						Modal.success({
							title: `${connector.name}  ${t("impaqx.adminApp.deleteConnectorApiMessage")}`,
							icon: <CheckCircleFilled />,
							okText: 'Close',
							//cancelText: 'Cancel',
							onOk() {
								//deleteApp(id);
							},
						});
						yield put(connectorList(res.data));
					} 
			 }
		 } catch (error) {
			const traceObj ={
				type: `delete_connector_api`,
				event: 'click',
				message: `Failed To Delete Connector Api`,
				status: `Failed To Delete Connector Api`,
				action: `Clicked delete connector api`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			 console.log(error);
			 if(error.response.data.status===401){
				yield put(showConnectorApisMessage(error.response));
			}
			 yield put(showConnectorApisMessage(error.response));
		 }
	})
}

export function* getInstanceConnector(){
    yield takeEvery (GET_INSTANCE_CONNECTORS_API_LIST, function*  ({requestData}){
		const {query, sorter,pagination,appId,appInstanceId} = requestData;
      const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountId: localStorage.getItem("accountId"),
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${CONNECTOR_BASE_URL}/connector/connector-instance-api?appId=${appId}&appInstanceId=${appInstanceId}&query=${query}&
		sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_instance_connector`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `Instance Connector Retrieve Sucessfully`,
						action: `Search instance connector`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_instance_connector`,
					event: 'click',
					message: `${res?.data?.totalElements} results found`,
					status: `Instance Connector Retrieve Sucessfully`,
					action: `Clicked get instance connector`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(connectorInstanceList(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_instance_connector`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Retrieve Instance Connector`,
					action: `Search instance connector`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_instance_connector`,
				event: 'click',
				message: `0 results found`,
				status: `Failed To Retrieve Instance Connector`,
				action: `Clicked get instance connector`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showConnectorApisMessage(err.response));
			}
			yield put(showConnectorApisMessage(err.response));
		}
    }

    )
}

export function* updateInstanceConnector(){
    yield takeEvery (UPDATE_INSTANCE_CONNECTOR_API,function* ({payload}){
		const {query, sorter,pagination,values,appId,appInstanceId} = payload;
		const config = {
			headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
			"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			accountId: localStorage.getItem("accountId"),
			accountUserId: localStorage.getItem("accountUserId") }
		  };
        try {
			var response;
			if(values.id){
				response = yield axios.put(`${CONNECTOR_BASE_URL}/connector/connector-instance-api/${values.id}`, values,config);
			}else{
                response = yield axios.post(`${CONNECTOR_BASE_URL}/connector/connector-instance-api`, values,config);
			}
             if (response.status===200) {
				const traceObj ={
					type: `update_instance_connector`,
					event: 'click',
					message: `Instance Connector Updated For Id=${values.id}`,
					status: `Instance Connector Updated`,
					action: `Clicked update instance connector`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				const res = yield  axios.get(`${CONNECTOR_BASE_URL}/connector/connector-instance-api?appId=${appId}&appInstanceId=${appInstanceId}&query=${query ?? ''}&
				sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${(pagination?.current ?? 1) - 1}&size=${pagination?.pageSize ?? 10}`,
				config);
					if (res.status===200) {
				Modal.success({
					title: t("impaqx.adminApp.connectorCreateMessage"),
					icon: <CheckCircleFilled />,
					okText: t("impaqx.adminApp.close"),
					//cancelText: 'Cancel',
					onOk() {
					  //deleteApp(id);
					},
				  });
				  yield put(connectorInstanceList(res.data));
				} 
		}
		yield put(hideLoading());
        } catch (error) {
			const traceObj ={
				type: `update_instance_connector`,
				event: 'click',
				message: `Failed To Update Instance Connector For Id=${values.id}`,
				status: `Failed To Update Instance Connector`,
				action: `Clicked update instance connector`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
            console.log(error);
			yield put(hideLoading());
			if(error.response?.data?.status===401){
				yield put(showConnectorApisMessage(error.response));
			}
			yield put(showConnectorApisMessage(error.response));
        }
    }
    )
}

export default function* rootSaga(){
    yield all([
		  fork(getConnector),
		  fork(deleteConnectorApi),
		  fork(saveConnector),
		  fork(updateConnector),
		  fork(testConnector),
		  fork(getInstanceConnector),
		  fork(updateInstanceConnector)
    ])
    
}